import type { ReactNode } from "react";
import React from "react";
import { ChatDealListRow } from "~/components/common/chat/deal_list/ChatDealListRow";
import { useMessageSummaries } from "~/hooks/vendors/useMessageSummaries";
import { useSessions } from "~/hooks/vendors/useSessions";
import type { MessageSummary } from "~/models/MessageSummary";
import { isUnreadForVendor } from "~/models/MessageSummary";

/**
 * チャットしている案件一覧
 *
 * @for vendor
 * @constructor
 */
export function ChatDealListRowsVendor() {
	const { data: session } = useSessions().index();
	const { data: messageSummaries } = useMessageSummaries().index();
	const getUnread = React.useCallback(
		(messageSummary: MessageSummary): boolean => {
			if (session === null || session.vendorCompany === null) {
				return false;
			}
			return isUnreadForVendor(messageSummary, session.vendorCompany.id);
		},
		[session]
	);
	const renderMessageSummary = React.useCallback(
		(messageSummary: MessageSummary): ReactNode => (
			<ChatDealListRow
				isVendor
				key={messageSummary.id}
				messageSummary={messageSummary}
				unread={getUnread(messageSummary)}
			/>
		),
		[getUnread]
	);
	if (messageSummaries === null) {
		return null;
	}
	return <div>{messageSummaries.map(renderMessageSummary)}</div>;
}
